import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PageHeaderWithActionBar from '@/components/common/Header/PageHeaderWithActionBar.vue'
import PageViewHeaderWithActionBar from '@/components/common/Header/PageViewHeaderWithActionBar.vue'
import HomeContainer from '@mail/containers/HomeContainer.vue'
import MoveModal from '@mail/components/Modals/MoveModal.vue'
import { mapGetters, mapMutations } from 'vuex'
import * as types from '@mail/store/types'
import { createEventBus, removeEventBus } from '@appbase/util'
import store from '@/store'
@Component({
    components: { 
        PageHeaderWithActionBar, 
        PageViewHeaderWithActionBar, 
        HomeContainer,
        MoveModal
    },
    computed: {
        ...mapGetters({
            selectList: types.EMAIL_SELECT
        })
    },
    methods: {
        ...mapMutations({
            selectListClear: types.EMAIL_SELECT_CLEAR,
        })
    }
})
export default class HomeView extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    selectList!: string[]

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    selectListClear!: () => void

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    
    openDropdown: boolean = false
    actionOpen: boolean = false
    moveModalShow: boolean = false

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get selectionCount() {
        return this.selectList.length
    }

    get isMailOnly() {
        const current = store.state.$account?.current
        if (current) {
            if (current.user.deptCode.indexOf('MAILONLY') > -1) {
                return true
            } else {
                return false
            }
        } else {
            return false
        } 
    }
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    deleteItems() {
        (this.$refs.homeContainer as any).deleteItems()
    }

    moveItems(folderId: string) {
        (this.$refs.homeContainer as any).moveItems(folderId)
    }

    readItems() {
        (this.$refs.homeContainer as any).readItems()
    }

    selectAll() {
        (this.$refs.homeContainer as any).selectAll()
    }

    handleBackRequest() {
        this.selectListClear()
    }

    moveModalClose() {
        this.moveModalShow = false
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        createEventBus(window, 'header-back', this.handleBackRequest)
    }

    beforeDestroy() {
        removeEventBus(window, 'header-back', this.handleBackRequest)
    }
}
